import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { DynamicAppModule } from './dynamic-app/dynamic-app.module';
import { buildingBlockComponents } from './dynamic-app/component/building-block/building-block.module';
import { EcpWorkflowComponent } from './ecp-workflow.component';
import { OaoModuleInit } from './oao/oao.module.init';
import { OlaModuleInit } from './ola/ola.module.init';
import { DynamicAppModuleInit } from './dynamic-app/dynamic-app.module.init';
import { OlaModule } from './ola/ola.module';
import { OaoModule } from './oao/oao.module';
import { DynamicAppRegistryModule } from './dynamic-app-registry/dynamic-app-registry.module';
import { ApiService } from '@workflow/ecp-shared/service/api/api.service';
import { AdminPortalFeaturesService } from '@workflow/ecp-shared/service/user/admin-portal-features.service';
import { DynamicWorkflowModule } from '@workflow/dynamic-workflow.module';
import { DynamicWorkflowInitializer } from '@workflow/helper/dynamic-workflow-initializer/dynamic-workflow-initializer.class';
import { CommonModalsModule } from './common-modals/common-modals.module';
import { RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [EcpWorkflowComponent],
  imports: [
    CommonModule,
    SharedUiLibraryModule,
    DynamicAppModule,
    OlaModule,
    OaoModule,
    CommonModalsModule,
    RecaptchaModule,
    RecaptchaV3Module,
    DynamicAppRegistryModule,
    DynamicWorkflowModule.withBuildingBlock(buildingBlockComponents),
    SharedModule
  ],
  exports: [DynamicWorkflowModule, OlaModule, OaoModule, CommonModalsModule, EcpWorkflowComponent],
  providers: [ApiService, AdminPortalFeaturesService]
})
export class EcpWorkflowModule {
  constructor(injector: Injector) {
    DynamicWorkflowInitializer.register(injector, null, OaoModuleInit.init(), OlaModuleInit.init(), DynamicAppModuleInit.init());
  }
}
